import React, { useState, useEffect } from 'react';
import { Form, Button, Alert, Spinner } from 'react-bootstrap';
import { reviewsApi } from '../services/api';

const LeaveReview = ({ business_id, reviews, setReviews }) => {
  const [review, setReview] = useState('');
  const [rating, setRating] = useState(5);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setLoading(true);
        const data = await reviewsApi.getByBusinessId(business_id);
        setReviews(data.reviews);
      } catch (err) {
        console.error('Error fetching reviews:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    if (business_id) {
      fetchReviews();
    }
  }, [business_id, setReviews]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const reviewData = {
        business_id,
        rating,
        text: review
      };

      await reviewsApi.submit(reviewData);
      setSuccess(true);
      setReview('');
      setRating(5);

      // Refresh reviews after submission
      const updatedReviews = await reviewsApi.getByBusinessId(business_id);
      setReviews(updatedReviews.reviews);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="my-4">
      <h3>Leave a Review</h3>
      
      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="info">Review submitted successfully!</Alert>}
      
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Rating</Form.Label>
          <Form.Select
            value={rating}
            onChange={(e) => setRating(Number(e.target.value))}
            disabled={loading}
          >
            <option value="5">⭐⭐⭐⭐⭐ (5 stars)</option>
            <option value="4">⭐⭐⭐⭐ (4 stars)</option>
            <option value="3">⭐⭐⭐ (3 stars)</option>
            <option value="2">⭐⭐ (2 stars)</option>
            <option value="1">⭐ (1 star)</option>
          </Form.Select>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Your Review</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={review}
            onChange={(e) => setReview(e.target.value)}
            placeholder="Write your review here..."
            disabled={loading}
            required
          />
        </Form.Group>

        <Button variant="primary" className="text-white" type="submit" disabled={loading}>
          {loading ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              Submitting...
            </>
          ) : (
            'Submit Review'
          )}
        </Button>
      </Form>
    </div>
  );
};

export default LeaveReview;
